(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDeleteController',SecurityRolesDeleteController);

    SecurityRolesDeleteController.$inject = ['$uibModalInstance', 'entity', 'SecurityRoles'];

    function SecurityRolesDeleteController($uibModalInstance, entity, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SecurityRoles.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
